import publicApiClient from './publicApi'

export interface UsageBucket {
  used: number
  limit: number
  remaining: number
}

export interface DailyUsage {
  date: string
  read: number
  write: number
}

export interface MonthlyUsage {
  read: UsageBucket
  write: UsageBucket
}

export interface ApiUsage {
  monthly: MonthlyUsage
  daily: DailyUsage[]
}

interface RawUsage {
  ok: boolean
  monthly: MonthlyUsage
  daily: DailyUsage[]
}

export const ApiUsageService = {
  get: async (): Promise<ApiUsage> => {
    const { data } = await publicApiClient.get<RawUsage>('/v1/usage')

    if (!data.ok) {
      throw new Error('Usage request failed')
    }

    return { monthly: data.monthly, daily: data.daily }
  },
}
